import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, inject, signal, viewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import Quagga, { QuaggaJSResultObject } from '@ericblade/quagga2';

@Component({
    selector: 'sl-barcode-scanner',
    templateUrl: './barcode-scanner.dialog.html',
    styleUrls: ['./barcode-scanner.dialog.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BarcodeScannerDialog implements AfterViewInit {
    readonly barcodeScannerContainer = viewChild.required('barcodeScannerContainer', { read: ElementRef });

    readonly isLoading = signal(true);
    readonly cameraPermission = signal<'ok' | 'dismissed' | 'blocked'>('ok');

    private readonly matDialogRef = inject(MatDialogRef);

    constructor() {
        this.matDialogRef.beforeClosed().subscribe(() => {
            Quagga.offDetected(this.onDetected.bind(this));
            Quagga.stop();
        });
    }

    ngAfterViewInit(): void {
        this.initialize();
    }

    initialize(): void {
        this.isLoading.set(true);
        this.cameraPermission.set('ok');
        navigator.mediaDevices
            .getUserMedia({ video: true, audio: false })
            .then(() => {
                Quagga.init(
                    {
                        inputStream: {
                            type: 'LiveStream',
                            target: this.barcodeScannerContainer().nativeElement
                        },
                        decoder: {
                            readers: ['code_128_reader']
                        }
                    },
                    this.quaggaCallback.bind(this)
                );
            })
            .catch((error: DOMException) => {
                this.isLoading.set(false);
                if (error.message === 'Permission dismissed') {
                    this.cameraPermission.set('dismissed');
                } else {
                    this.cameraPermission.set('blocked');
                }
            });
    }

    quaggaCallback(): void {
        this.isLoading.set(false);
        Quagga.start();
        Quagga.onDetected(this.onDetected.bind(this));
    }

    onDetected(result: QuaggaJSResultObject): void {
        if (!!result.codeResult?.code) {
            this.matDialogRef.close(result.codeResult.code);
        }
    }
}
